import { getLabelMessage } from '@gef-ui/localization/messages';
import { passSx } from '@gef-ui/material/components/utils';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';
import omit from "ramda/es/omit";
import React from 'react';
import { useDefaultComponentValue } from '../../utils';
import { CloseButton, DetailButton, RefreshButton } from '../ActionButtons';
const COMPONENT_NAME = 'InlineError';
const InlineError = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { onRefresh, onClose, onDetail, message, messageTemplate = (message)=>`${getLabelMessage('common:error').toUpperCase()}: ${message}`, backdrop, AlertProps = {} } = props;
    return /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        variant: 'outlined',
        sx: [
            backdrop && {
                width: '100%',
                position: 'absolute',
                zIndex: (theme)=>theme.zIndex.drawer + 2,
                backgroundColor: 'background.paper'
            },
            (theme)=>({
                    [theme.breakpoints.down('md')]: {
                        flexDirection: 'column',
                        '& .MuiAlert-action': {
                            '& button': {
                                ml: 0,
                                pl: 0
                            },
                            flexDirection: 'column',
                            ml: 0,
                            p: 0
                        }
                    }
                }),
            ...passSx(AlertProps.sx)
        ],
        action: /*#__PURE__*/ React.createElement(React.Fragment, null, onDetail && /*#__PURE__*/ React.createElement(DetailButton, {
            size: "small",
            onClick: onDetail
        }), onRefresh && /*#__PURE__*/ React.createElement(RefreshButton, {
            size: "small",
            onClick: onRefresh
        }), onClose && /*#__PURE__*/ React.createElement(CloseButton, {
            size: "small",
            onClick: onClose
        })),
        ...omit([
            'sx'
        ], AlertProps)
    }, messageTemplate(message));
};
InlineError.propTypes = {
    AlertProps: PropTypes.object,
    backdrop: PropTypes.bool,
    message: PropTypes.string.isRequired,
    messageTemplate: PropTypes.func,
    onClose: PropTypes.func,
    onDetail: PropTypes.func,
    onRefresh: PropTypes.func,
    sx: PropTypes.object
};
export default InlineError;
